export default __webpack_public_path__ + "54a12d9416ec865229ffdb0d78391bef.png";